import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { useFlightLoadingDetails } from "@apac/hooks";
import { Loading } from "@b2bportal/core-ui";
import {
  getChildState,
  getParentState,
  ParentState,
  CartQuoteState,
  useCheckoutState,
} from "@hopper-b2b/checkout";
import { PATH_HOME, PATH_FLIGHTS } from "@hopper-b2b/common-utils";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BLoadingPopup } from "@hopper-b2b/ui";
import { ErrorModal, LoadingScreen } from "@hsbc/portal";
import type { FlightMachineContext } from "@hsbc/types";
import type { TEvent } from "../events";

const ConnectedLoadingScreen = (props) => {
  const [state] = useCheckoutState<TEvent, FlightMachineContext>();
  const parentState = getParentState(state.value);
  const childState = getChildState(state.value);
  const { context: loadingContext } = useFlightLoadingDetails();

  const { t } = useI18nContext();
  const getMessage = useCallback(() => {
    switch (parentState) {
      case ParentState.loading:
      case ParentState.cancelForAnyReason:
      case ParentState.cancelForAnyReasonV2:
      case ParentState.disruptionV1:
      case ParentState.cartUpdate:
      case ParentState.cartUpdateBeforeFulfill:
        return t("loading");
      default:
        return "";
    }
  }, [parentState, t]);

  const navigate = useNavigate();
  const searchAgain = () => {
    navigate(`${PATH_HOME}${PATH_FLIGHTS}`);
  };

  const errorState = useMemo(() => {
    //TODO: add error states for loading and cart update when these endpoints fail.
    return childState === CartQuoteState.error;
  }, [childState]);

  return errorState ? (
    // TODO: add correct errors for scenarios
    <ErrorModal
      open={errorState}
      title={t("checkoutError.genericErrorTitle")}
      subtitle={t("checkoutError.genericErrorSubtitle")}
      primaryButtonText={t("checkoutError.searchAgain")}
      primaryOnClick={searchAgain}
    />
  ) : (
    <LoadingScreen
      isLoading={true}
      flightLoadingDetails={loadingContext}
      loadingSteps={[{ title: getMessage() }]}
    />
  );
};

export { ConnectedLoadingScreen as LoadingScreen };
